var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms__content" }, [
    _c("h3", { staticClass: "sc-xbo55n-1 bKHNUv" }, [_vm._v("COOKIE POLICY")]),
    _c("div", { staticClass: "sc-9no5sp-1 yTZFM" }, [
      _c("div", { staticClass: "sc-9no5sp-2 gJAKYk" }, [
        _c("p", [
          _vm._v(
            "This cookie policy explains how we use cookies and other similar technologies when you use our service, what tracking technologies are and why we use them. It also explains how you can control their use."
          )
        ]),
        _c("p", [
          _vm._v("If you have any questions you can contact us at "),
          _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
            _vm._v(_vm._s(_vm.supportEmail))
          ]),
          _vm._v(". ")
        ]),
        _c("h3", [_vm._v("Cookies")]),
        _vm._m(0),
        _vm._m(1),
        _vm._m(2),
        _c("h3", [_vm._v("Similar technologies")]),
        _c("p", [
          _vm._v(
            "In addition to cookies, there are other similar technologies that may be used on the web or in mobile ecosystems."
          )
        ]),
        _vm._m(3),
        _c("h3", [
          _vm._v("How can you manage your cookies and similar technologies?")
        ]),
        _vm._m(4),
        _vm._m(5),
        _vm._m(6),
        _c("p", [
          _vm._v(
            "Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary from browser to browser, and from version to version. You can however obtain up-to-date information about blocking and deleting cookies via these links:"
          )
        ]),
        _vm._m(7),
        _vm._m(8),
        _c("p", [
          _vm._v(
            "Please note that blocking all cookies will have a negative impact on the usability of many websites. If you block cookies, you will not be able to use all the features on our website."
          )
        ]),
        _vm._m(9),
        _vm._m(10),
        _vm._m(11),
        _c("p", [
          _vm._v(
            "The third-party advertisers, ad agencies and vendors with which we work may be members of the Network Advertising Initiative, the Digital Advertising Alliance Self-Regulatory Program for Online Behavioural Advertising, the European Digital Advertising Alliance. To opt-out of interest-based advertising from the participating companies, visit the following links:"
          )
        ]),
        _vm._m(12),
        _c("h3", [_vm._v("Cookies list")]),
        _c("p", [
          _vm._v(
            "You can find more information about the individual cookies we use and the purposes for which we use them in the table below:"
          )
        ]),
        _vm._m(13),
        _vm._m(14),
        _vm._m(15),
        _vm._m(16),
        _c("h3", [_vm._v("Changes to this policy")]),
        _c("p", [
          _vm._v(
            "We may change this policy from time to time, when we do we will inform you by updating the “Last updated” date below."
          )
        ]),
        _c("p", [_vm._v("Last updated: Match 25, 2024.")])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "A cookie is a small text file which is placed onto your device (e.g. computer, smartphone or other electronic device) when you visit our website to store a range of information, for example, your language preference, or browser and device you are using to view the website. Those cookies are set by us and called "
      ),
      _c("em", [_vm._v("first-party cookies")]),
      _vm._v(". We also use "),
      _c("em", [_vm._v("third party cookies")]),
      _vm._v(
        ", which are cookies from a domain different from the domain of our website, for our advertising and marketing efforts."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("em", [_vm._v("Session cookies")]),
      _vm._v(
        " expire each time you close your browser and do not remain on your device afterwards. These cookies allow our website to link your actions during a particular browser session."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("em", [_vm._v("Persistent cookies")]),
      _vm._v(
        " will remain on your device for a period of time, and will expire on a set expiration date, or when you delete them manually from your cache. These cookies are stored on your device in between browser sessions and allow your preferences and actions across our website to be remembered."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("em", [_vm._v("Web beacon")]),
        _vm._v(
          " is a small, transparent image (also known as “pixel tag”, “web bug”, “GIF”) that contains a unique identifier. It is embedded into a website or an email. When your browser reads the code of the website it communicates with our server in order to display the image and, through this process, we are able to acquire information such as technical specifications of your device, operating systems and settings being used. It can also track your activities during a session. Also, it enables us to recognize when each email was opened, from what IP address and from what device. We use this information to improve our email communication."
        )
      ]),
      _c("li", [
        _c("em", [_vm._v("Software development kits (SDK) ")]),
        _vm._v(
          "are third-party software development kits that may be installed in our mobile applications. SDKs help us understand how you interact with our mobile applications and collect certain information about the device and network you use to access the application."
        )
      ]),
      _c("li", [
        _c("em", [_vm._v("Local shared objects")]),
        _vm._v(
          ", commonly called “Flash cookies”, are pieces of data that websites which use Adobe Flash may store on a user's computer to facilitate the Flash functionality. We may use Adobe Flash to display graphics, interactive animations and other enhanced functionality. Local shared objects can track similar parameters to cookies but they can also provide information on your use of the specific feature that the cookie is enabling. For example, if it facilitates the display of a video then we can receive details of how much of the video was watched and when viewing stopped. Flash cookie management tools can be accessed directly via "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.adobe.com/",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("www.adobe.com")]
        ),
        _vm._v(".")
      ]),
      _c("li", [
        _c("em", [_vm._v("HTML5 local storage")]),
        _vm._v(
          ". HTML 5 is the fifth version of the HTML language and contains functionality that allows information to be stored locally within the browser’s data files. HTML5 local storage operates in a similar way to cookies but differs in that it can hold greater amounts of information and does not rely on an exchange of data with the website’s server."
        )
      ]),
      _c("li", [
        _c("em", [_vm._v("Fingerprinting")]),
        _vm._v(
          " is a technique that involves combining a set of information elements in order to uniquely identify a particular device. These information elements include, for example: data from configuration of the device, CSS information, JavaScript objects, installed fonts, installed plugins with the browser, use of any APIs, HTTP header information, clock information."
        )
      ]),
      _c("li", [
        _c("em", [_vm._v("Device Identifiers")]),
        _vm._v(
          " are identifiers comprised of numbers and letters, which are unique to each specific device. These include Apple’s ID for Advertisers (IDFA) and Google’s Android Advertising ID (AAID). They are stored on the device and are used to recognize you and your devices across different apps and devices for marketing and advertising purposes. You can reset your device identifier or opt out of personalized advertising in the settings of your device."
        )
      ]),
      _c("li", [
        _c("em", [_vm._v("Social widgets ")]),
        _vm._v(
          "are buttons or icons provided by third-party social media providers that allow you to interact with those social media services when you view a web page or a mobile app screen. These social widgets may collect browsing data, which may be received by the third party that provided the widget, and are controlled by the third parties."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [_c("strong", [_vm._v(" Consent management tool")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "You can manage your cookie preferences on a consent management platform that appears when you visit the website or when you click on the “"
      ),
      _c("em", [_vm._v("Privacy”")]),
      _vm._v(
        " icon at the right bottom corner of any page of our website. It may be necessary to refresh the page for the updated settings to take effect. Essential cookies cannot be disabled, nor can the tool be used to block cookies on third-party websites linked to our website."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { attrs: { start: "2" } }, [
      _c("li", [_c("strong", [_vm._v(" Browser and device settings")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://support.google.com/chrome/answer/95647",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Chrome")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Firefox")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.opera.com/help/tutorials/security/cookies/",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Opera")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Internet Explorer")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Safari")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("Edge")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Detailed instructions on how to control your cookies through browser settings can also be found here: "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.aboutcookies.org/how-to-control-cookies/",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("https://www.aboutcookies.org/how-to-control-cookies/")]
      ),
      _vm._v(".")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "To reset your device identifier or opt-out of personalized advertising, follow "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://support.google.com/googleplay/android-developer/answer/6048248?hl=en",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Google instructions")]
      ),
      _vm._v(" or "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://support.apple.com/en-gb/HT205223#:~:text=To%20reset%20your%20Advertising%20Identifier%20on%20macOS%2C%20choose%20Apple%20menu,be%20less%20relevant%20to%20you.",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Apple instructions")]
      ),
      _vm._v(".")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "To opt out of data usage by Google Analytics follow instructions: "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://tools.google.com/dlpage/gaoptout",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("https://tools.google.com/dlpage/gaoptout")]
      ),
      _vm._v(".")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { attrs: { start: "3" } }, [
      _c("li", [
        _c("strong", [_vm._v(" Opt-out of internet-based advertising")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("Network Advertising Initiative "),
        _c(
          "a",
          {
            attrs: {
              href: "http://optout.networkadvertising.org/",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("http://optout.networkadvertising.org/")]
        )
      ]),
      _c("li", [
        _vm._v("Digital Advertising Alliance "),
        _c(
          "a",
          {
            attrs: {
              href: "http://optout.aboutads.info/",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("http://optout.aboutads.info/")]
        )
      ]),
      _c("li", [
        _vm._v("Digital Advertising Alliance (Canada) "),
        _c(
          "a",
          {
            attrs: {
              href: "http://youradchoices.ca/choices",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("http://youradchoices.ca/choices")]
        )
      ]),
      _c("li", [
        _vm._v("Digital Advertising Alliance (EU) "),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.youronlinechoices.com/",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("http://www.youronlinechoices.com/")]
        )
      ]),
      _c("li", [
        _vm._v("DAA AppChoices page "),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.aboutads.info/appchoices/",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("http://www.aboutads.info/appchoices")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _c("strong", [_vm._v("Strictly necessary cookies.")]),
        _vm._v(
          " These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { attrs: { start: "2" } }, [
      _c("li", [
        _c("strong", [_vm._v("Analytical or performance cookies.")]),
        _vm._v(
          " These allow us to recognize and count the number of visitors, to know which pages are the most and least popular, and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { attrs: { start: "3" } }, [
      _c("li", [
        _c("strong", [_vm._v("Functionality cookies.")]),
        _vm._v(
          "These are used to recognize you when you return to our website. This enables us to personalise our content for you, greet you by name and remember your preferences (for example, your choice of language or region). They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { attrs: { start: "4" } }, [
      _c("li", [
        _c("strong", [_vm._v(" Targeting cookies.")]),
        _vm._v(
          " These cookies record your visit to our website, the pages you have visited and the links you have followed. We will use this information to make our website and the advertising displayed on it more relevant to your interests. These cookies may be set through our website by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }